/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl-next';

import { cssMap, jsx } from '@atlaskit/css';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import ProgressBar from '@atlaskit/progress-bar';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

const styles = cssMap({
	container: {
		gap: token('space.100'),
	},
	progressContainer: {
		width: '100%',
		borderRadius: token('radius.small'),
	},
});

export const ProgressBarWithMessage = ({ progress }: { progress: number }): JSX.Element => {
	const { formatMessage } = useIntl();

	const progressBarAppearance = progress === 1 ? 'success' : 'default';

	return (
		<Stack xcss={styles.container}>
			<Box xcss={styles.progressContainer}>
				<ProgressBar
					value={progress}
					appearance={progressBarAppearance}
					ariaLabel="Provisioning in progress"
				/>
			</Box>
			<Text align="center" size="small" color="color.text.subtlest">
				{formatMessage(messages.progress)}
			</Text>
		</Stack>
	);
};
